import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { NgxSpinnerService } from "ngx-spinner";
import { LivroRegistro } from '../../models/livro-registro';
import { BuscaService } from '../../services/busca.service';

@Component({
    selector: 'busca',
    templateUrl: './busca.component.html',
    styleUrls: ['./busca.component.scss'],
    standalone: false
})
export class BuscaComponent implements OnInit {

  isCollapsed = true;

  instituicoes: any;
  @Input() ies: any;

  buscaForm: UntypedFormGroup;
  dadosBusca: {
    "codCurso": 0,
    "codInstituicaoEnsino": 0
  };

  captcha: string = "";

  resultadosBusca: LivroRegistro;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private _busca: BuscaService
  ) {
    this.buscaForm = this._formBuilder.group({
      Instituicao: ['Selecione uma instituição', Validators.required],
      Nome: ['', Validators.required],
      Captcha: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.generateCaptcha();

    // Define a lista de instituições
    this._busca.getInstituicao(this.ies.codigo).subscribe(response => {
      let listaIinstituicoes = response.listarTodasInstituicoesEnsinoResult.instituicaoEnsinoDTO;

      if (listaIinstituicoes.length > 0) {
        this.instituicoes = listaIinstituicoes.sort((a, b) => {
          return a.nome > b.nome ? 1 : -1;
        });

        if (listaIinstituicoes.length == 1) {
          this.buscaForm.controls['Instituicao'].setValue(listaIinstituicoes[0].codInstituicao);
        }
      }
    }, error => {
      console.log(error);
    });
  }

  generateCaptcha() {
    let a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let n = "0123456789";

    // Captcha length
    let cap_size = 4;
    let captchaTemp = "";

    while (cap_size--) {
      // if 0 add a random alphabetic character
      if (this.rand(2) === 0) captchaTemp += a[this.rand(a.length)];
      // if 1 add a random numeric character
      else captchaTemp += n[this.rand(n.length)];
    }

    this.captcha = captchaTemp;
  }

  rand(x: number) {
    return Math.floor(Math.random() * x);
  }

  buscar(pageSize: number, pageNumber: number, e?: Event,) {
    this.spinnerFunction();

    setTimeout(() => {
      if (e) {
        e.preventDefault();
      }

      if (this.validacao()) {
        let dados = {
          'codCurso': null,
          'codInstituicaoEnsino': parseInt(this.buscaForm.controls['Instituicao'].value),
          'nomeAluno': this.buscaForm.controls['Nome'].value,
          'numRegistroDiploma': null
        };

        this._busca.getResultado(dados, pageSize, pageNumber).subscribe(response => {
          this.resultadosBusca = response;

          // Scroll
          setTimeout(() => {
            document.getElementById("Resultado").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          }, 250);

          this.isCollapsed = false;
        }, error => {
          console.log(error);
        });
      } else {
        return;
      }
    }, 1000);
  }

  pageChanged(event: PageChangedEvent) {
    this.buscar(event.itemsPerPage, event.page);
  }

  validacao() {
    let errorInstitiucao = document.getElementById("error-message-instituicao");
    let errorNome = document.getElementById("error-message-nome");
    let errorCaptcha = document.getElementById("error-message-captcha");

    let divInstituicao = document.getElementById('input-instituicao');
    let divNome = document.getElementById('input-nome');
    let divCaptcha = document.getElementById('input-captcha');

    errorInstitiucao.style.display = 'none';
    errorNome.style.display = 'none';
    errorCaptcha.style.display = 'none';

    divInstituicao.style.boxShadow = 'none';
    divNome.style.boxShadow = 'none';
    divCaptcha.style.boxShadow = 'none';

    if (this.captcha == this.buscaForm.controls['Captcha'].value) {
      if (this.buscaForm.controls['Instituicao'].value === 'Selecione uma instituição') {
        errorInstitiucao.style.display = "block";
        errorInstitiucao.innerHTML = "Selecione uma instituição";
        errorInstitiucao.classList.add('hasError', 'hasErrorInstituicao');
        divInstituicao.style.boxShadow = '0 0 5px red';
      }

      if (this.buscaForm.controls['Nome'].value) {
        return true;
      } else {
        return false;
      }
    } else {
      errorCaptcha.style.display = "block";
      errorCaptcha.innerHTML = "Captcha incorreto!";
      errorCaptcha.style.color = "red";
      errorCaptcha.classList.add('hasError');
      divCaptcha.style.boxShadow = '0 0 5px red';

      return false;
    }
  }

  spinnerFunction() {
    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }
}
